// The homepage's small diamond (a turned square): a domain's or a gift's colour beside its name.

export function Diamond({ color, className = "" }: { color: string; className?: string }) {
  return <span aria-hidden="true" className={`inline-block h-2.5 w-2.5 shrink-0 rotate-45 rounded-[2px] ${className}`} style={{ backgroundColor: color }} />;
}
